import api from '../../../services/api';

export type ProposalStatus =
  | 'PENDING'
  | 'APPROVED'
  | 'REJECTED'
  | 'EXECUTED'
  | 'FAILED'
  | 'EXPIRED';
export type AgentName = 'nami' | 'zoro' | 'brook' | 'luffy';

export interface PreviewItem {
  key: string;
  label: string;
  detail?: string;
}

export interface ProposalPreview {
  title: string;
  details: Array<{ label: string; value: string }>;
  email?: {
    subject: string;
    excerpt: string;
    html: string;
    recipientCount?: number;
    skippedCount?: number;
  };
  /** Itens de uma proposta em lote; o Marcus desmarca o que não quer (spec §6.1). */
  items?: PreviewItem[];
}

/** A forma do item do "Contrato com o Hermes" (plano 2026-10-15). */
export interface AgentProposal {
  id: number;
  /** String, não AgentName: propostas históricas podem ter agente que não existe mais. */
  agent: string;
  actionType: string;
  status: ProposalStatus;
  summary: string;
  payload: Record<string, unknown>;
  preview: ProposalPreview;
  createdAt: string;
  expiresAt: string;
  decidedAt: string | null;
  decidedBy: { id: number; name: string } | null;
  decisionNote: string | null;
  executedAt: string | null;
  result: Record<string, unknown> | null;
  error: string | null;
  link: string;
  excludedItems: string[];
}

export interface ProposalListParams {
  status?: ProposalStatus | undefined;
  agent?: AgentName | undefined;
  limit?: number | undefined;
}

export interface ProposalListResponse {
  items: AgentProposal[];
  total: number;
}

/** Omite o que está vazio: `status=` tomaria 400 no isIn da rota. */
function toParams(params: ProposalListParams): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (params.status) {
    out.status = params.status;
  }
  if (params.agent) {
    out.agent = params.agent;
  }
  if (params.limit !== undefined) {
    out.limit = params.limit;
  }
  return out;
}

export const agentProposalsService = {
  list: (params: ProposalListParams = {}) =>
    api
      .get<ProposalListResponse>('/agent-proposals', { params: toParams(params) })
      .then((r) => r.data),

  get: (id: number) => api.get<AgentProposal>(`/agent-proposals/${id}`).then((r) => r.data),

  approve: (id: number, note?: string, excludedItems?: string[]) =>
    api
      .post<AgentProposal>(`/agent-proposals/${id}/approve`, {
        ...(note ? { note } : {}),
        ...(excludedItems && excludedItems.length > 0 ? { excludedItems } : {}),
      })
      .then((r) => r.data),

  reject: (id: number, note?: string) =>
    api
      .post<AgentProposal>(`/agent-proposals/${id}/reject`, note ? { note } : {})
      .then((r) => r.data),
};
